import React, { useContext, useEffect, useRef, useState } from 'react'
import { ContentCardType } from '@futures-platform/ui'
// import { phenomenonColor } from "../../helpers/phenomenonColor";
import { getPhenomenonUrl } from '../../helpers/contentCard'
import { fetcher as fetcherAPI } from '../../helpers/fetcher'
import { DataContext } from '../../store/GlobalState'
import styles from './RelatedPhenomena.module.css'

const RelatedPhenomena = ({ phenomena }) => {
  const cardBodyRef = useRef()
  const cardBodyRef2 = useRef()

  const {
    state: { langForTransState, isTranslated },
    dispatch,
  } = useContext(DataContext)

  const [translations, settranslations] = useState(null)
  const [originalTitle, setoriginalTitle] = useState(
    () => cardBodyRef.current?.innerHTML,
  )

  useEffect(() => {
    const fetcher = async () => {
      const res1 = await fetcherAPI.translation(
        'en',
        langForTransState,
        originalTitle,
      )
      settranslations(() => {
        return {
          res1,
        }
      })
    }
    !!isTranslated && !!originalTitle && fetcher()
  }, [isTranslated, originalTitle, langForTransState])

  useEffect(() => {
    if (!!phenomena) {
      if (true) {
        if (!!cardBodyRef.current?.innerHTML && !cardBodyRef2.current) {
          cardBodyRef2.current = cardBodyRef.current?.innerHTML
        }
        !!cardBodyRef2.current &&
          !originalTitle &&
          setoriginalTitle(() => cardBodyRef2.current)

        // dispatch({
        //   type: ACTIONS.GETWHOLEHTMLCARD2,
        //   payload:  true
        // })
      }
    }
  }, [isTranslated, phenomena, dispatch, originalTitle])

  return (
    !!phenomena?.length && (
      <>
        {!isTranslated ? (
          <div className={styles.relatedPhenomenaWrapper} ref={cardBodyRef}>
            <h3 className={styles.h2Title}>Related phenomena</h3>
            <div className="">
              {!!phenomena &&
                !!phenomena?.length &&
                phenomena?.map((phe) => {
                  // phenomenaTypesData && phenomenaTypesData?.map(type => {
                  //   if(type.id === phe.content.type) {
                  //     phe['content-type-alias'] = type.alias;
                  //     phe['content-type-title'] = type.title;
                  //     phe['color'] = phe.content.type.includes('fp:doc-types') ? String(type.style.color): 'none'
                  //   }
                  // })
                  // const {iconClassName, backgroundColor} = phenomenonColor(phe);
                  const isFpGroup =
                    Number(phe?.group) === 0 ||
                    (!!phe?.groups?.length && Number(phe?.groups[0]) === 0)
                  // phe['radarGroupId'] = Number(gid)
                  return (
                    <a
                      // href="#abc"
                      rel="noreferrer noopener"
                      target="_blank"
                      className={styles.phenLink}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      key={phe?.id}>
                      <div
                        className={`content-card right ${styles.phenWrapper}`}
                        data-href={getPhenomenonUrl(false, phe)}
                        style={{
                          cursor: 'pointer',
                          alignItems: 'center',
                          display: 'flex',
                          alignContent: 'center',
                        }}
                        data-position="right">
                        {/* <div className={`icon-issue ${iconClassName}`} style={{marginTop: '1px'}}></div> */}
                        <ContentCardType
                          isFpGroup={isFpGroup}
                          contentType={phe?.['content-type-alias']}
                          customTypeStyleColor={phe?.['color']}
                        />
                      </div>

                      <h4
                        className={`content-card right ${styles.phenName}`}
                        data-href={getPhenomenonUrl(false, phe)}
                        style={{
                          cursor: 'pointer',
                          marginBottom: 0,
                          marginTop: 0,
                        }}
                        data-position="right">
                        {phe?.content?.title}
                      </h4>
                    </a>
                  )
                })}
            </div>
          </div>
        ) : (
          <div
            className={styles.relatedPhenomenaWrapper}
            ref={cardBodyRef}
            dangerouslySetInnerHTML={{
              __html: translations?.res1?.data,
            }}></div>
        )}
      </>
    )
  )
}

export default RelatedPhenomena
